// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---trJH2","changedRecordsList":"changedRecordsList---bM8bq","changedRecord":"changedRecord---sOXde"};